import { PersoneriaRepresent } from './../../../models/personeria_represent.model';
import { ChangeDetectorRef, Component } from "@angular/core";
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import * as moment from 'moment';


declare var jQuery: any;
declare var $: any;
@Component({
  selector: 'app-personeria-representante',
  templateUrl: './personeria-representante.component.html',
  styleUrls: ['./personeria-representante.component.css'],
  providers: [FormService]
})


export class PersoneriaRepresentanteComponent {
  private lastLoadedTimestamp: number = 0;
  public rows = [];
  public actualRow;
  public personeria: PersoneriaRepresent;
  public formulario;


  constructor(public _formService: FormService, private fb: FormBuilder, private cdr: ChangeDetectorRef) {
    this.formulario = new FormGroup({
      aMediante: new FormControl(''),
      aFecha: new FormControl(''),
      escrituraFecha: new FormControl(''),
      notario: new FormControl(''),
      medInstrumento: new FormControl(''),
      oMediante: new FormControl(''),
      oFecha: new FormControl(''),
    })

    if (!JSON.parse(localStorage.getItem("personeria"))) {
      localStorage.setItem("personeria", JSON.stringify(this.rows));
    } else {
      this.rows = JSON.parse(localStorage.getItem("personeria"));
      this.formulario.controls['aMediante'].setValue(this.rows[0] ? this.rows[0].aMediante : '');
      this.formulario.controls['aFecha'].setValue(this.rows[0] ? this.rows[0].aFecha : '');
      this.formulario.controls['escrituraFecha'].setValue(this.rows[0] ? this.rows[0].escrituraFecha : '');
      this.formulario.controls['notario'].setValue(this.rows[0] ? this.rows[0].notario : '')
      this.formulario.controls['medInstrumento'].setValue(this.rows[0] ? this.rows[0].medInstrumento : '');
      this.formulario.controls['oMediante'].setValue(this.rows[0] ? this.rows[0].oMediante : '');
      this.formulario.controls['oFecha'].setValue(this.rows[0] ? this.rows[0].oFecha : '');
    }
    this.personeria = {
      aMediante: '',
      aFecha: '',
      escrituraFecha: '',
      notario: '',
      medInstrumento: '',
      oMediante: '',
      oFecha: '',
    }
  }

  intervalId: any;

  ngOnInit() {
    // Cargar los datos iniciales
    this.loadFromLocalStorage();

    // Revisar periódicamente cambios en el localStorage
    this.intervalId = setInterval(() => {
      this.loadFromLocalStorage();
    }, 1000); // Revisa cada segundo
  }

  ngOnDestroy() {
    // Limpiar el intervalo cuando el componente se destruye
    clearInterval(this.intervalId);
  }

 loadFromLocalStorage() {
  const storedData = JSON.parse(localStorage.getItem('personeria'));

  if (storedData && storedData.length > 0) {
    const data = storedData[0];

    if (data.timestamp && data.timestamp !== this.lastLoadedTimestamp) {
      this.lastLoadedTimestamp = data.timestamp;
      this.rows = storedData;

      this.formulario.controls["aMediante"].setValue(data.aMediante || "");
      this.formulario.controls["aFecha"].setValue(data.aFecha ? new Date(data.aFecha) : "");
      this.formulario.controls["escrituraFecha"].setValue(data.escrituraFecha ? new Date(data.escrituraFecha) : "");
      this.formulario.controls["notario"].setValue(data.notario || "");
      this.formulario.controls["medInstrumento"].setValue(data.medInstrumento || "");
      this.formulario.controls["oMediante"].setValue(data.oMediante || "");
      this.formulario.controls["oFecha"].setValue(data.oFecha ? new Date(data.oFecha) : "");

      this.cdr.detectChanges();
    }
  }
}

  add_personeria() {
    //var checkDeclaracion = event.value;
    localStorage.setItem("personeria", JSON.stringify([]))
    this.actualRow = localStorage.getItem("personeria");
    this.rows = JSON.parse(this.actualRow);
    this.rows = this.rows.concat({
      aMediante: this.formulario.value.aMediante,
      aFecha: this.formulario.value.aFecha ? moment(this.formulario.value.aFecha).format('DD/MM/YYYY') : "",
      escrituraFecha: this.formulario.value.escrituraFecha ? moment(this.formulario.value.escrituraFecha).format('DD/MM/YYYY') : "",
      notario: this.formulario.value.notario,
      medInstrumento: this.formulario.value.medInstrumento,
      oMediante: this.formulario.value.oMediante,
      oFecha: this.formulario.value.oFecha ? moment(this.formulario.value.oFecha).format('DD/MM/YYYY') : "",
    })

    localStorage.setItem("personeria", JSON.stringify(this.rows));
  }

  delete_personeria(id) {
    for (let x = 0; x < this.rows.length; x++) {
      if (id == x) {
        this.rows.splice(x, 1);
        localStorage.setItem("personeria", JSON.stringify(this.rows));
      }
    }
  }

}
